// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingCalendar_container__x4Teh","slot":"LoadingCalendar_slot__LwKni","calendar":"LoadingCalendar_calendar__x80kL"};